import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const GtmScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()
    const {tagManager} = commerceAPI
    const {config} = tagManager || {}

    let googleTagManagerEnabled = false
    let gtagContainerID = null

    try {
        const jsonConfig = JSON.parse(config)
        googleTagManagerEnabled = jsonConfig.gtmEnabled
        gtagContainerID = jsonConfig.gtagContainerID
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (
            gtagContainerID &&
            googleTagManagerEnabled &&
            !document.querySelector(
                `script[src*="googletagmanager.com/gtm.js?id=${gtagContainerID}"]`
            ) // Check if GTM script is already loaded
        ) {
            const inlineScript = document.createElement('script')
            inlineScript.type = 'text/javascript'
            inlineScript.async = true
            inlineScript.defer = true
            inlineScript.innerHTML = `
                (function(w,d,s,l,i){
                    w[l]=w[l]||[];
                    w[l].push({'gtm.start': new Date().getTime()});
                    var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
                    j.async=true;
                    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                    f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtagContainerID}');
            `

            document.head.appendChild(inlineScript)

            return () => {
                document.head.removeChild(inlineScript)
            }
        }
    }, [gtagContainerID])

    return null
}

export default GtmScript
